// Mock data for StoryBox Solutions website

export const teamMembers = [
  {
    id: 1,
    name: "Rajesh Kumar",
    position: "Chief Executive Officer",
    image: "https://images.unsplash.com/photo-1758599543154-76ec1c4257df?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwxfHxidXNpbmVzcyUyMHByb2Zlc3Npb25hbCUyMGhlYWRzaG90fGVufDB8fHx8MTc2MjIzNzE5NHww&ixlib=rb-4.1.0&q=85",
    bio: "15+ years of experience in IT solutions and business strategy."
  },
  {
    id: 2,
    name: "Priya Sharma",
    position: "Chief Technology Officer",
    image: "https://images.unsplash.com/photo-1758518729459-235dcaadc611?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHw0fHxidXNpbmVzcyUyMHByb2Zlc3Npb25hbCUyMGhlYWRzaG90fGVufDB8fHx8MTc2MjIzNzE5NHww&ixlib=rb-4.1.0&q=85",
    bio: "Expert in software architecture and emerging technologies."
  },
  {
    id: 3,
    name: "Amit Patel",
    position: "Head of Development",
    image: "https://images.unsplash.com/photo-1758599543136-5977bf2dd922?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwyfHxidXNpbmVzcyUyMHByb2Zlc3Npb25hbCUyMGhlYWRzaG90fGVufDB8fHx8MTc2MjIzNzE5NHww&ixlib=rb-4.1.0&q=85",
    bio: "Leads development teams with 12+ years of coding expertise."
  },
  {
    id: 4,
    name: "Sneha Reddy",
    position: "QA Manager",
    image: "https://images.pexels.com/photos/3777565/pexels-photo-3777565.jpeg",
    bio: "Specializes in quality assurance and testing methodologies."
  },
  {
    id: 5,
    name: "Vikram Singh",
    position: "Data Architect",
    image: "https://images.unsplash.com/photo-1758876204244-930299843f07?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwzfHxidXNpbmVzcyUyMHByb2Zlc3Npb25hbCUyMGhlYWRzaG90fGVufDB8fHx8MTc2MjIzNzE5NHww&ixlib=rb-4.1.0&q=85",
    bio: "Expert in data warehouse solutions and big data technologies."
  },
  {
    id: 6,
    name: "Ananya Desai",
    position: "Mobile App Lead",
    image: "https://images.pexels.com/photos/2182970/pexels-photo-2182970.jpeg",
    bio: "Passionate about creating innovative Android applications."
  }
];

export const services = [
  {
    id: 'software-development',
    title: 'Software Development',
    shortDesc: 'Custom software solutions tailored to your business needs',
    icon: 'Code',
    image: 'https://images.unsplash.com/photo-1521737711867-e3b97375f902?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwyfHxzb2Z0d2FyZSUyMGRldmVsb3BtZW50JTIwdGVhbXxlbnwwfHx8fDE3NjIyMzcyMDN8MA&ixlib=rb-4.1.0&q=85',
    fullDesc: 'We specialize in delivering high-quality custom software solutions that drive business growth. Our team of experienced developers uses cutting-edge technologies and industry best practices to create robust, scalable, and maintainable applications.',
    features: [
      'Custom Web Applications',
      'Enterprise Software Solutions',
      'API Development & Integration',
      'Cloud-Based Solutions',
      'Legacy System Modernization',
      'Agile Development Methodology'
    ],
    technologies: ['React', 'Node.js', 'Python', 'Java', 'AWS', 'Azure']
  },
  {
    id: 'android-development',
    title: 'Android Development',
    shortDesc: 'Native Android applications with exceptional user experience',
    icon: 'Smartphone',
    image: 'https://images.unsplash.com/photo-1748256622734-92241ae7b43f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwzfHxzb2Z0d2FyZSUyMGRldmVsb3BtZW50JTIwdGVhbXxlbnwwfHx8fDE3NjIyMzcyMDN8MA&ixlib=rb-4.1.0&q=85',
    fullDesc: 'Our Android development team creates powerful, user-friendly mobile applications that engage users and deliver results. We follow Material Design guidelines and implement the latest Android features to ensure your app stands out.',
    features: [
      'Native Android Apps',
      'Material Design Implementation',
      'Play Store Optimization',
      'App Performance Optimization',
      'Push Notifications Integration',
      'In-App Purchases & Monetization'
    ],
    technologies: ['Kotlin', 'Java', 'Android SDK', 'Firebase', 'Room DB']
  },
  {
    id: 'software-testing',
    title: 'Offshore Software Testing',
    shortDesc: 'Comprehensive QA and testing services ensuring quality delivery',
    icon: 'CheckCircle',
    image: 'https://images.unsplash.com/photo-1521737852567-6949f3f9f2b5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwxfHxzb2Z0d2FyZSUyMGRldmVsb3BtZW50JTIwdGVhbXxlbnwwfHx8fDE3NjIyMzcyMDN8MA&ixlib=rb-4.1.0&q=85',
    fullDesc: 'Our dedicated QA team provides comprehensive testing services to ensure your software meets the highest quality standards. We employ automated and manual testing methodologies to identify and resolve issues before they impact your users.',
    features: [
      'Functional Testing',
      'Performance Testing',
      'Security Testing',
      'Automation Testing',
      'User Acceptance Testing',
      'Continuous Integration Testing'
    ],
    technologies: ['Selenium', 'JUnit', 'TestNG', 'Postman', 'JMeter']
  },
  {
    id: 'data-warehouse',
    title: 'Data Warehouse Management',
    shortDesc: 'Efficient data storage and analytics solutions for informed decisions',
    icon: 'Database',
    image: 'https://images.unsplash.com/photo-1497366754035-f200968a6e72?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHw1fHxidXNpbmVzcyUyMHByb2Zlc3Npb25hbCUyMGhlYWRzaG90fGVufDB8fHx8MTc2MjIzNzE5NHww&ixlib=rb-4.1.0&q=85',
    fullDesc: 'Transform your raw data into actionable insights with our data warehouse solutions. We design and implement scalable data architectures that enable efficient data storage, retrieval, and analysis for better business intelligence.',
    features: [
      'Data Warehouse Design',
      'ETL Process Implementation',
      'Data Migration Services',
      'Business Intelligence Solutions',
      'Real-time Data Processing',
      'Data Quality Management'
    ],
    technologies: ['SQL Server', 'Oracle', 'PostgreSQL', 'Snowflake', 'Apache Spark']
  }
];

export const products = [
  {
    id: 1,
    name: 'StoryBox CRM',
    description: 'Complete customer relationship management solution designed for growing businesses',
    features: ['Contact Management', 'Sales Pipeline', 'Analytics Dashboard', 'Email Integration'],
    image: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHw0fHxidXNpbmVzcyUyMHByb2Zlc3Npb25hbCUyMGhlYWRzaG90fGVufDB8fHx8MTc2MjIzNzE5NHww&ixlib=rb-4.1.0&q=85'
  },
  {
    id: 2,
    name: 'StoryBox Inventory',
    description: 'Streamline your inventory management with real-time tracking and automated alerts',
    features: ['Stock Management', 'Barcode Scanning', 'Purchase Orders', 'Reports & Analytics'],
    image: 'https://images.unsplash.com/photo-1497366754035-f200968a6e72?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHw1fHxidXNpbmVzcyUyMHByb2Zlc3Npb25hbCUyMGhlYWRzaG90fGVufDB8fHx8MTc2MjIzNzE5NHww&ixlib=rb-4.1.0&q=85'
  },
  {
    id: 3,
    name: 'StoryBox Analytics',
    description: 'Advanced business intelligence platform for data-driven decision making',
    features: ['Custom Dashboards', 'Predictive Analytics', 'Data Visualization', 'API Access'],
    image: 'https://images.unsplash.com/photo-1521737852567-6949f3f9f2b5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwxfHxzb2Z0d2FyZSUyMGRldmVsb3BtZW50JTIwdGVhbXxlbnwwfHx8fDE3NjIyMzcyMDN8MA&ixlib=rb-4.1.0&q=85'
  }
];

export const testimonials = [
  {
    id: 1,
    name: 'Suresh Mehta',
    company: 'TechCorp India',
    position: 'CTO',
    text: 'StoryBox Solutions delivered our enterprise software on time and within budget. Their expertise in software development is unmatched.',
    rating: 5
  },
  {
    id: 2,
    name: 'Kavita Nair',
    company: 'FinServe Solutions',
    position: 'Project Manager',
    text: 'The Android app they developed exceeded our expectations. User engagement increased by 200% within the first month.',
    rating: 5
  },
  {
    id: 3,
    name: 'Manish Gupta',
    company: 'DataFlow Systems',
    position: 'CEO',
    text: 'Their data warehouse solution transformed how we handle business intelligence. Highly recommended!',
    rating: 5
  }
];

export const careerOpenings = [
  {
    id: 1,
    title: 'Senior Full Stack Developer',
    location: 'Bangalore, India',
    type: 'Full-time',
    experience: '5+ years',
    department: 'Engineering'
  },
  {
    id: 2,
    title: 'Android Developer',
    location: 'Mumbai, India',
    type: 'Full-time',
    experience: '3+ years',
    department: 'Mobile Development'
  },
  {
    id: 3,
    title: 'QA Engineer',
    location: 'Pune, India',
    type: 'Full-time',
    experience: '2+ years',
    department: 'Quality Assurance'
  },
  {
    id: 4,
    title: 'Data Engineer',
    location: 'Hyderabad, India',
    type: 'Full-time',
    experience: '4+ years',
    department: 'Data & Analytics'
  }
];
